import React from 'react';
import { SmallColors } from '../Colors';

export const ProductColors = ({ colors, onHover }) => (
  <SmallColors colors={colors} onHover={onHover} />
);
